import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { reloadOnceForNewBuild } from "./lib/lazyRoute";
import { ensureStylesheets } from "./lib/stylesheetGuard";

// Vite reports a missing preloaded chunk (stale tab after a deploy): fetch the new build once instead of failing.
window.addEventListener("vite:preloadError", (event) => {
  if (reloadOnceForNewBuild()) event.preventDefault();
});

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");
// Never start on an unstyled page: a failed stylesheet is fetched again, or the page reloads.
void ensureStylesheets().then((ready) => {
  if (!ready) return;
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
